<script>
import CriteriaValueTypeInputFactory from 'frontend/common/data-tables/search-criteria/factories/CriteriaValueTypeInputFactory.vue'
import { getCriteriaValueTypeByConfig } from 'frontend/common/data-tables/search-criteria/functions/getCriteriaValueTypeByConfig'
import FormLabel from 'frontend/common/ea-form-controls/_form-label.vue'
import { ref } from 'vue'

import { predicateMappings } from './_search-criterion-predicate-config.js'

export default {
  name: 'SearchCriterion',
  emits: ['update:modelValue'],
  props: {
    attribute: {
      type: String,
      required: true,
    },
    config: {
      type: Object,
      required: true,
    },
    modelValue: {
      type: Object,
    },
  },
  setup() {
    return {
      ccontCollection: [
        { value: 'valid_value', label: 'A valid OSL' },
        { value: 'no_service', label: 'No service' },
        { value: 'not_ready', label: 'Not ready' },
      ],
      predicateMappings,
      resourceOptions: ref([]),
      getCriteriaValueTypeByConfig,
    }
  },

  methods: {
    searchKey(predicate) {
      return `${this.attribute}${this.predicateMappings[predicate].suffix}`
    },
    valueChanged(p, newVal) {
      const newValue = Object.assign({}, this.modelValue)
      if (typeof newVal === 'undefined' || (Array.isArray(newVal) && newVal.length === 0)) {
        delete newValue[this.searchKey(p)]
      } else {
        newValue[this.searchKey(p)] = newVal
      }
      this.$emit('update:modelValue', newValue)
    },
  },
  components: {
    FormLabel,
    CriteriaValueTypeInputFactory,
    // TODO - pieczor - why that imports?
    // DatetimeWithVariablesInput: defineAsyncComponent(() =>
    //   import('./datetime-with-variables-input.vue'),
    // ),
    // DatetimeRangeWithVariablesInput: defineAsyncComponent(() =>
    //   import('./datetime-range-with-variables-input.vue'),
    // ),
    // TaggableSelect: defineAsyncComponent(() =>
    //   import('frontend/common/selects/taggable-select.vue'),
    // ),
    // ResourceSelectInput: defineAsyncComponent(() => import('./resource-select-input.vue')),
  },
}
</script>

<template lang="pug">
.ea-filter-input-container(v-for="p in config.predicates" :key="predicateMappings[p].name")
  FormLabel(:label="predicateMappings[p].name")
  CriteriaValueTypeInputFactory(
    :criteriaValueType="getCriteriaValueTypeByConfig(config, p)"
    :criterion="config"
    :key="searchKey(p)"
    :modelValue="modelValue[searchKey(p)]"
    :name="`filters.${searchKey(p)}`"
    :predicate="p"
    @update:modelValue="valueChanged(p, $event)"
  )
</template>
